import io from "socket.io-client"
import { writable } from "svelte/store"

import App from "./App.svelte"

import Store from "./stores/index"
import { restartDefault } from "./stores/join"

import pack from "../package.json" // @TODO: is this dangerous or not?

let token = localStorage.getItem('token')
let connected = writable(false)

const path = new URL(window.location.href).pathname.substr(1)
const regex = /^[0-9]{3}-[0-9]{3}$/
const room = regex.exec(path)?.input || null

const isPROD = window.location.host !== "localhost"
const socket = io(isPROD?'':':3001', {path: '/socket.io/', query: { 
	token,
	...(room && {room}),
	version: pack.version
}})

let mode = "PLAY"

socket.on('token', newToken => {
	localStorage.setItem('token', newToken)
	token = newToken
	socket.query.token = newToken
})
socket.on('state', newState => Store.state.set(newState))

socket.on('host', newData => Store.host.set(newData))
socket.on('update', newData => Store.host.set(newData))

socket.on('join', newData => {
	Store.join.set(newData)
	socket.emit('mode', mode)
})
socket.on('version', version => {
	Store.version.set(version)
	if (version.frontend !== version.backend) {
		Store.crash.set(`Ups! Neatbilstoša spēles versija.`)
	}
})
socket.on('ready', newData => Store.pickedReady.set(newData))
socket.on('cards', newData => Store.cards.set(newData))
socket.on('pick', newData => Store.pick.set(newData))
socket.on('points', newData => Store.points.set(newData))
socket.on('userData', newData => Store.userData.set(newData))
socket.on('options', newData => Store.options.set(newData))
socket.on('position', newData => Store.position.set(newData))
socket.on('pickedOption', newData => Store.pickedOption.set(newData))

socket.on('disconnect', () => {
	connected.set(false)
	Store.crash.set("Pazuda savienojums ar serveri!")
})
socket.on('profile', newProfile => {
	connected.set(true)
	Store.profile.set({...newProfile, found: true})
})

socket.on('hostingCanceled', () => {
	Store.showMessage.set("Hmmm... Hosts aizvēra serveri!")	
})
socket.on('roomNotExist', () => {
	Store.showMessage.set("Hmmm... šāda istaba neeksistē.")
	history.pushState({}, `KVIZ.party`, `/`)
	restartDefault()
})

const switchMode = (newMode) => {
	mode = newMode
}

const app = new App({
	target: document.body,
	props: {
		connected,
		socket,
		switchMode
	}
})

export default app
